<template>
  <div id="thanks">
    <el-container>
      <el-header><i class="fas fa-check-circle fa-fw"></i>発注を承りました。</el-header>
      <el-main>
      <el-card class="box-card">
        <p>発注いただきありがとうございます。</p>
        <p>発注番号は、{{ $route.query.order_id }}です。</p>
        <p>発注確認メールを送信しましたので、ご確認ください。</p>
      </el-card>
      </el-main>
      <el-footer>
      <router-link to="/hist">
        <el-button type="primary" icon="el-icon-s-order">発注管理</el-button>
      </router-link>
      <router-link to="/map">
        <el-button type="primary" icon="el-icon-map-location">エリア選択</el-button>
      </router-link>
      </el-footer>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  props: ['user'],
  setup(props) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access Thanks page for not login.')
      router.push({ path: '/login' })
    }
  }
})
</script>

<style scoped>
#thanks {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#thanks .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#thanks .el-container {
    width: 550px;
    margin: 0 auto;
}
button {
  margin-left: 10px;
}
</style>